import React, { createContext, useReducer, useEffect, useState } from "react";
import { PRODUCT_REPOSITORY_TYPE } from "./ActionType";
import { getProducts } from "../service/productService";

const initialState = {
  searchTerm: "",
  category: null,
  tag: null,
  sorter: null,
  pageSize: 25,
  pageNumber: 1,
};

export const ProductRepositoryReducer = (state, action) => {
  switch (action.type) {
    case PRODUCT_REPOSITORY_TYPE.UPDATE_PAGE_SIZE: {
      return { ...state, pageSize: action.payload };
    }
    case PRODUCT_REPOSITORY_TYPE.UPDATE_PAGE_NUMBER: {
      return { ...state, pageNumber: action.payload };
    }
    case PRODUCT_REPOSITORY_TYPE.SEARCH: {
      return { ...state, searchTerm: action.payload };
    }
    case PRODUCT_REPOSITORY_TYPE.UPDATE_CATEGORY: {
      let temp = action.payload;

      if (action.payload === "") temp = null;
      return { ...state, category: temp };
    }
    case PRODUCT_REPOSITORY_TYPE.UPDATE_TAG: {
      return { ...state, tag: action.payload };
    }
    default:
      return state;
  }
};

export const ProductRepositoryContext = createContext();

export const ProductRepositoryProvider = ({ children }) => {
  const [products, setProducts] = useState([]);
  const [total, setTotal] = useState(0);
  const [state, dispatch] = useReducer(ProductRepositoryReducer, initialState);

  useEffect(() => {
    const filter = { category: state.category, tag: state.tag };
    const fetchData = async () => {
      const { products, total } = await getProducts(
        state.pageNumber,
        state.pageSize,
        state.sorter,
        filter
      );

      setProducts(products);
      setTotal(total);
    };

    fetchData();
  }, [state]);

  return (
    <ProductRepositoryContext.Provider
      value={{ state, dispatch, products, total }}
    >
      {children}
    </ProductRepositoryContext.Provider>
  );
};
